<template class="full-height">
  <div class="travel-all-container" style="position: relative; height: 100%; padding: 15px">
    <news-data />
  </div>
</template>
<script>
export default {
  name: 'travelNews',
  components: {
    newsData: () => import('@/views/ita/components/itemData.vue'),
  },
}
</script>
<style>
.full-height {
  position: relative;
  height: 100%;
}
</style>
